import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'

import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import MenuItem from '@material-ui/core/MenuItem'

import { TitleGrid, Word } from '../../../containers'
import { openingRuleItems, OPENING_RULE } from '../../../constants'
import { makePath } from '../../../lib';
import { WID } from '../../../constants/Language';
import { useState } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { types } from '../../../constants/ActionTypes'

const styles = theme => ({
  card: {
    margin: "20px auto",
    width: '100%',
    maxWidth: '680px',
  },
  cardHeader: {
    paddingTop: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 3,
    paddingBottom: 0,
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing.unit * 3,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 250,
  },
  textFieldFullWidth: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
    maxWidth: 500 + theme.spacing.unit * 2,
  },
  formControl: {
    display: 'block',
  },
});

const LiveSettings = (props) => {
  const { classes, liveId, handleStart } = props
  
  const [isInitialized, setIsInitialized] = useState(false)
  const [openingRule, setOpeningRule] = useState(OPENING_RULE.NONE)
  const [title, setTitle] = useState('')
  const [blackPlayerName, setBlackPlayerName] = useState('')
  const [whitePlayerName, setWhitePlayerName] = useState('')

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const history = useHistory()

  const dispatch = useDispatch()
  
  useEffect(() => {
    if (!isInitialized) {
      dispatch({ type: types.liveSettings.INIT })
      setIsInitialized(true)
    }
  }, [isInitialized])

  useEffect(() => {
    if (liveId && isInitialized) {
      history.push(makePath('/live/' + liveId, language))
    }
  }, [liveId, isInitialized])

  return (
    <TitleGrid titleType='live'>
      <Card className={classes.card}>
        <CardHeader className={classes.cardHeader} title={<Word wid={WID.LIVE_SETTINGS.CARD_TITLE}/>}/>
        <CardContent>
          <FormControl className={classes.formControl}>
            <TextField
              label={<Word wid={WID.LIVE_SETTINGS.OPENINGS_LABEL}/>}
              select
              className={classes.textField}
              onChange={(event) => setOpeningRule(event.target.value)}
              value={openingRule}
              margin="normal"
            >
              {openingRuleItems.map(item => 
                <MenuItem key={item.value} value={item.value}>
                  <Word wid={item.wid}/>
                </MenuItem>
              )}
            </TextField>
          </FormControl>
          <FormControl className={classes.formControl}>
            <TextField
              label={<Word wid={WID.LIVE_SETTINGS.GAME_TITLE}/>}
              className={classes.textFieldFullWidth}
              onChange={(event) => setTitle(event.target.value)}
              value={title}
              margin="normal"
            />
          </FormControl>
          <FormControl>
            <TextField
              label={<Word wid={WID.LIVE_SETTINGS.PLAYER_NAME_FIRST}/>}
              className={classes.textField}
              onChange={(event) => setBlackPlayerName(event.target.value)}
              value={blackPlayerName}
              margin="normal"
            />
          </FormControl>
          <FormControl>
            <TextField
              label={<Word wid={WID.LIVE_SETTINGS.PLAYER_NAME_SECOND}/>}
              className={classes.textField}
              onChange={(event) => setWhitePlayerName(event.target.value)}
              value={whitePlayerName}
              margin="normal"
            />
          </FormControl>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Button className={classes.button} variant="contained" color="primary" aria-label="Delete" onClick={handleStart(openingRule, title, blackPlayerName, whitePlayerName)}>
            <Word wid={WID.LIVE_SETTINGS.START}/>
          </Button>
          <Button color="primary" autoFocus component={Link} to={makePath('/live', language)}>
            Close
          </Button>
        </CardActions>
      </Card>
    </TitleGrid>
  )
}

export default withMobileDialog()(withStyles(styles)(LiveSettings))


// WEBPACK FOOTER //
// ./src/Pages/Live/components/LiveSettings.js